export const radius = {
  xs: '8px',
  md: '12px',
  large: '24px',
  pill: '999px',
  circle: '50%',
  default: 'var(--radius-md)'
};
